import React from "react"

import { Skeleton } from "@/shared/ui/skeleton"

export const EmptyDashboardSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col overflow-auto bg-gray-900 text-gray-100">
      <div className="mx-auto w-full max-w-3xl flex-1 p-6 pb-32 sm:pb-28 md:pb-6">
        {/* Header skeleton with icon */}
        <div className="mb-8 text-center">
          <div className="mb-4 flex items-center justify-center">
            <Skeleton className="h-16 w-16 rounded-2xl" />
          </div>
          <Skeleton className="mx-auto mb-2 h-8 w-64" />
          <Skeleton className="mx-auto h-5 w-80" />
        </div>

        {/* Group selector or add button skeleton */}
        <div className="mb-8">
          <Skeleton className="h-20 w-full rounded-2xl" />
        </div>

        {/* Quick Access heading */}
        <Skeleton className="mb-4 h-6 w-32" />

        {/* 2-column grid for feature cards */}
        <div className="mb-8 grid grid-cols-2 gap-3 sm:gap-4">
          <Skeleton className="h-24 rounded-xl" />
          <Skeleton className="h-24 rounded-xl" />
        </div>

        {/* Info cards skeleton (3 cards stacked) */}
        <div className="space-y-4">
          <Skeleton className="h-20 rounded-xl" />
          <Skeleton className="h-20 rounded-xl" />
          <Skeleton className="h-20 rounded-xl" />
        </div>
      </div>
    </div>
  )
}
